import templateUrl from 'webutils/heading.htm'

export default { 
    bindings : {
        left: '@',
        right: '@'
    },
    transclude: {
        left: '?left',
        right: '?right',
    },
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};